/* Package JSON Import will be here */
import React, { Fragment } from "react";
import { getTranslate } from "react-localize-redux";
import { Input } from "antd";
import { useSelector } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner";
/* Project Import will be here */

const DirectLoginForm = props => {
  const { translate } = useSelector((state) => ({
    translate: getTranslate(state.locale)
  }));

  return (
    <Fragment>
      <div span={24} md={24} className="font-12 p-1 font-bold">
        {translate("session.common.mobileNumber")}
      </div>

      <Input
        size="large"
        placeholder={translate("session.common.mobileNumber")}
        className="sign-in-input-height round-radius"
        value={props.userName}
      />

      <div className="pt-4 pb-4">
        <Spinner message={translate("session.signIn.loading.retailerLoading")} />
      </div>
    </Fragment>
  );
};

export default DirectLoginForm;